import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { HeroSection } from "../Components/Home";
import { About } from "../Components/About";
import Projects from "../Components/Projects";
import Skills from "../Components/Skills";
import Experience from "../Components/Experience";
import Achievements from "../Components/Achievements";
import Blogs from "../Components/Blogs";
import Testimonails from "../Components/Testimonails";
import Footer from "../Components/Footer";
import { Element } from "react-scroll";

const sectionWrapperStyle = {
  pos: "relative",
  w: "full",
  h: "full",
  px: "8",
  my: "8",
};

const Wrapper = ({ children, name }) => {
  return (
    <Element name={name} id={name}>
      <Box as="section" {...sectionWrapperStyle}>
        {children}
      </Box>
    </Element>
  );
};
const HomePage = () => {
  return (
    <Box
      as="main"
      w="100vw"
      pos="relative"
      overflow="hidden"
      boxSizing="border-box"
    >
      {/* home hero section */}
      <Box as="section" pos="relative" w="100vw" h="100vh">
        <HeroSection />
      </Box>
      {/* about section */}
      <Wrapper children={<About />} name="about" />
      {/* Projects Section */}
      <Wrapper children={<Projects />} name="projects" />
      {/* Skill section */}
      <Wrapper children={<Skills />} name="skills" />
      {/* Experience section */}
      <Wrapper children={<Experience />} name="experience" />
      {/* Achivements section */}
      <Wrapper children={<Achievements />} name="achievements" />
      {/* Blogs section */}
      <Wrapper children={<Blogs />} name="blogs" />
      {/* testimonails section for images */}
      <Wrapper children={<Testimonails />} name="testimonial" />
      {/* contact section */}
      {/* <Wrapper children={<ContactForm />} name="testimonial" /> */}
      <Box w="full" h="full" pos="relative">
        <Footer />
      </Box>
    </Box>
  );
};

export default HomePage;
